import { identity } from '../utils/helper';
/**
 * Connector transfom by function.
 */
export const Custom = (options) => {
    const { callback = identity } = options;
    return (data) => callback(data);
};
Custom.props = {};
//# sourceMappingURL=custom.js.map